import { formatNullableCurrency } from "./formatNullableCurrency";

interface FormatCheckPriceLabelOptions {
  currency?: string | null;
  locale?: string;
  priceIsCatalogMinimum?: boolean;
  fromPrefix?: string;
}

/**
 * Formats a check price for display. Prefixes with "From" when the amount is a
 * catalog minimum (final price may vary by jurisdiction or product code).
 */
export function formatCheckPriceLabel(
  price: unknown,
  {
    currency,
    locale = "en-US",
    priceIsCatalogMinimum = false,
    fromPrefix = "From ",
  }: FormatCheckPriceLabelOptions
): string | null {
  const formatted = formatNullableCurrency(price, {
    currency,
    locale,
    fallback: null,
  });

  if (!formatted) {
    return null;
  }

  return priceIsCatalogMinimum ? `${fromPrefix}${formatted}` : formatted;
}
